import { DestinationDetail } from '@/types/destinationDetail'
import { DetailSection } from '@/components/detail/DetailSection'
import { FieldGrid, FieldItem } from '@/components/detail/FieldGrid'
import { compareDateYmd } from '@/utils/dateUtils'
import { css, useTheme } from '@emotion/react'

const appliedDateContainerStyle = css`
  margin-bottom: 32px;
`

type Props = {
  data: DestinationDetail
}

export const DestinationView = ({ data }: Props) => {
  const theme = useTheme()

  const getStartDateIndicator = () => {
    if (compareDateYmd(data.startDate, data.startDateCurr ?? new Date()) === 0) {
      return { type: 'dotAndText' as const, color: theme.c.bc.active, text: '現在適用中' }
    }
    if (data.startDatePending && compareDateYmd(data.startDate, data.startDatePending) === 0) {
      return { type: 'dotAndText' as const, color: theme.c.bc.inactive, text: '適用待ち' }
    }
    if (compareDateYmd(data.startDate, data.startDateCurr ?? new Date()) < 0) {
      return { type: 'dotAndText' as const, color: theme.c.bc.inactive, text: '適用終了' }
    }
    return undefined
  }

  return (
    <>
      <div css={appliedDateContainerStyle}>
        <FieldItem
          label="適用開始日"
          value={new Intl.DateTimeFormat('ja-JP', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          }).format(new Date(data.startDate))}
          indicator={getStartDateIndicator()}
        />
      </div>
      <DetailSection number={1} title="基本情報" isFirst={true}>
        <FieldGrid>
          <FieldItem label="送達先番号" value={data.destinationCode} />
          <FieldItem label="送達先名" value={data.destinationName} />
          <FieldItem label="都道府県" value={data.prefectureName} />
        </FieldGrid>
      </DetailSection>
      <DetailSection number={2} title="住所・連絡先">
        <FieldGrid>
          <FieldItem label="郵便番号" value={data.postalCode} />
          <FieldItem label="住所1" value={data.addressLine1} />
          <FieldItem label="住所2" value={data.addressLine2 || ''} />
          <FieldItem label="電話番号" value={data.phoneNumber || ''} />
          <FieldItem label="FAX番号" value={data.faxNumber || ''} />
          <FieldItem
            label="送達先電話番号"
            value={data.destinationsPhoneNumber || ''}
          />
        </FieldGrid>
      </DetailSection>
    </>
  )
}
